export const conteudos = {
  hero: {
    label: 'Conteúdos',
    title: 'Análise Técnica e Estrutural',
    subtitle: 'Artigos sobre engenharia patrimonial, governança e execução disciplinada. Sem promessas. Com método.',
  },
  articles: [
    {
      category: 'Engenharia Patrimonial',
      title: 'Estruturação de Crédito via Consórcio: Variáveis e Restrições',
      excerpt: 'Análise técnica das variáveis que impactam a estruturação de crédito através de consórcios regulamentados.',
      date: '15 Jan 2024',
      readTime: '8 min',
    },
    {
      category: 'Governança',
      title: 'Modelagem de Cenários: Base e Stress Testing',
      excerpt: 'Como construir cenários realistas e testes de estresse para decisões patrimoniais estruturadas.',
      date: '10 Jan 2024',
      readTime: '12 min',
    },
    {
      category: 'Método',
      title: 'Diagnóstico Patrimonial: Além do Perfil de Risco',
      excerpt: 'Metodologia para análise estrutural que vai além de questionários convencionais de perfil.',
      date: '05 Jan 2024',
      readTime: '10 min',
    },
    {
      category: 'Execução',
      title: 'Cartas Contempladas: Curadoria e Validação Documental',
      excerpt: 'Processo técnico de validação, análise de risco operacional e acompanhamento de transferência.',
      date: '28 Dez 2023',
      readTime: '9 min',
    },
    {
      category: 'Estruturação Empresarial',
      title: 'Aquisição de Ativos Corporativos: Governança e Clareza',
      excerpt: 'Como estruturar aquisições de sede própria e ativos operacionais com método e transparência.',
      date: '20 Dez 2023',
      readTime: '11 min',
    },
    {
      category: 'Análise',
      title: 'Regulamentos de Consórcio: Leitura Crítica e Variáveis-Chave',
      excerpt: 'Guia técnico para análise de regulamentos, identificação de restrições e variáveis operacionais.',
      date: '15 Dez 2023',
      readTime: '14 min',
    },
  ],
  cta: {
    title: 'Estruture Seu Patrimônio com Método',
    subtitle: 'Agendar um diagnóstico estratégico e receber análise técnica personalizada.',
    primary: 'Agendar Diagnóstico Estratégico',
    secondary: 'Falar com Especialista',
  },
};